import React from 'react'
import './index.css'
import { createRoot } from 'react-dom/client'
import App from './App'
import './i18n'

import { Provider } from 'react-redux'
import { store } from './redux/store'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement as HTMLElement)
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)
